module.exports = __webpack_public_path__ + "static/img/header_logo_h5.cf98cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/header_logo_h5.png
// module id = wULi
// module chunks = 11